



































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import CountriesStore from "@/mixins/constants/countriesStore";

@Component
export default class TaxTagLocations extends Mixins(CountriesStore) {
  // Props

  @Prop({ default: () => [] })
  public locations!: any[];

  @Prop({ default: 5 })
  public limit!: number;

  // Computed

  public get allGroupedLocations() {
    return _.map(_.uniqBy(this.locations, "country_id"), location => {
      return {
        id: location.id,
        label: this.getCountryPropValue(location.country_id, "name"),
        regions: this.getRegionsCount(location.country_id),
        postCodes: this.getPostcodesCount(location.country_id)
      };
    });
  }

  public get groupedLocations() {
    return _.slice(this.allGroupedLocations, 0, this.limit);
  }

  // Methods

  public getRegionsCount(countryId) {
    return _.uniqBy(
      _.filter(
        this.locations,
        location =>
          location.country_id === countryId && !_.isNull(location.region_id)
      ),
      "region_id"
    ).length;
  }

  public getPostcodesCount(countryId) {
    return _.uniqBy(
      _.filter(
        this.locations,
        location =>
          location.country_id === countryId && !_.isNull(location.post_code)
      ),
      "post_code"
    ).length;
  }
}
